// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-sidebar-scroll {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 6px;
  margin-right: -6px;
}

/* Webkit browsers (Chrome, Safari, etc) */
.custom-sidebar-scroll::-webkit-scrollbar {
  width: 6px;
}

.custom-sidebar-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.custom-sidebar-scroll::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.custom-sidebar-scroll::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Firefox */
.custom-sidebar-scroll {
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/Layout.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,qBAAqB;EACrB,6BAA6B;AAC/B","sourcesContent":[".custom-sidebar-scroll {\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-right: 6px;\n  margin-right: -6px;\n}\n\n/* Webkit browsers (Chrome, Safari, etc) */\n.custom-sidebar-scroll::-webkit-scrollbar {\n  width: 6px;\n}\n\n.custom-sidebar-scroll::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 10px;\n}\n\n.custom-sidebar-scroll::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 10px;\n}\n\n.custom-sidebar-scroll::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n/* Firefox */\n.custom-sidebar-scroll {\n  scrollbar-width: thin;\n  scrollbar-color: #888 #f1f1f1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
